import {
    collection,
  } from 'common/store/selectors';
  
  const getScope = ({ device: { tagsHistory } }) => tagsHistory;
  
  const collectionSelectors = collection.factory(getScope);
  
  export const {
    getPaginator,
    isLoading,
  } = collectionSelectors;
  
  export const getTagsHistoryContext = collectionSelectors.getCollectionContext;
  export const getTagsHistoryMaybe = collectionSelectors.getCollectionMaybe;
  